/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { Tab } from '../../../core/model/tab.model';

@Component({
  selector: 'lms-alert-header',
  templateUrl: './alert-header.component.html',
  styleUrls: ['./alert-header.component.scss']
})
export class AlertHeaderComponent {

  configData: any;
  @Input() refreshTime: any;
  @Input() selectedTab: Tab;
  @Output() refreshAlerts = new EventEmitter();
  lastUrl: string;
  tabLevel: number;

  /**
   * Creates an instance of AlertHeaderComponent.
   * @param {ConfigService} configService
   * @param {LmsLoaderService} lmsLoaderService
   * @memberof AlertHeaderComponent
   */
  constructor(private configService: ConfigService, private lmsLoaderService: LmsLoaderService,
    private lmsRendererService: LmsRendererService, private appUtilService: AppUtilityService) {
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.topTabs;
  }

  /**
   * this method is used to emit the refresh
   * event when user clicks on refresh icon
   * @memberof AlertHeaderComponent
   */
  refreshAlertsInfo() {
    this.lmsLoaderService.showLoader();
    this.refreshAlerts.emit('refresh');
  }

  gotoPreviousScreen() {
    const tab = this.lmsRendererService.getLastUrl();
    this.appUtilService.navigateByUrl(tab.type, tab.subType, tab.tabSearchParameter.searchText, true, true, tab.id);
  }

  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toUpperCase() : letter.toLowerCase();
    }).replace(/\s+/g, '');
  }

}
